import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react";
import { baseUrl } from "../constant";

const lobbyBaseQuery = fetchBaseQuery({
  baseUrl,
  prepareHeaders: (headers, { endpoint }) => {
    if (String(endpoint).startsWith("admin")) {
      const token = localStorage.getItem("token");
      if (token) headers.set("Authorization", `Bearer ${token}`);
    }
    return headers;
  },
});

export const lobbyBannerApi = createApi({
  reducerPath: "lobbyBannerApi",
  baseQuery: lobbyBaseQuery,
  tagTypes: ["LobbyBanners"],
  endpoints: (build) => ({
    getLobbyBanners: build.query({
      query: () => "/lobby/banners",
      providesTags: ["LobbyBanners"],
    }),
    adminGetLobbyBanners: build.query({
      query: (section = "") => ({
        url: "/lobby/admin/list",
        method: "POST",
        body: section ? { section } : {},
      }),
      providesTags: ["LobbyBanners"],
    }),
    adminSaveLobbyBanner: build.mutation({
      query: (formData) => ({
        url: "/lobby/admin/save",
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["LobbyBanners"],
    }),
    adminDeleteLobbyBanner: build.mutation({
      query: (body) => ({
        url: "/lobby/admin/delete",
        method: "POST",
        body,
      }),
      invalidatesTags: ["LobbyBanners"],
    }),
  }),
});

export const {
  useGetLobbyBannersQuery,
  useAdminGetLobbyBannersQuery,
  useAdminSaveLobbyBannerMutation,
  useAdminDeleteLobbyBannerMutation,
} = lobbyBannerApi;
